import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FileInputWrapper, Folder, LaptopIcon} from "./styles";
import {Box, Flex, Text} from "rebass";
import {DesktopBox, MobileBox,} from "../../Base";

class FileUpload extends Component {
	state = {
		files: []
	}

	handleUpload = (e) => {
		e.preventDefault()
		const files = Array.from(e.target.files)

		const {handleFile} = this.props;
		handleFile(e)
		this.setState({files})
	}

	render() {
		return (
			<FileInputWrapper>
				<Flex p={2}>
					<Box>
						<DesktopBox>
							<LaptopIcon/>
						</DesktopBox>
						<MobileBox><Folder/></MobileBox>
					</Box>
					<Box>
						<DesktopBox>

							<Text pl={2} pt={'4px'} fontSize={'15px'}>Your Computer</Text>
						</DesktopBox>
						<MobileBox><Text textAlign='center' pl={2} pt={'4px'} fontSize={'15px'}>Attach a
							file</Text></MobileBox>
					</Box>
				</Flex>
				<input type="file" name="file" onChange={this.handleUpload}/>

			</FileInputWrapper>
		);
	}
}

FileUpload.propTypes = {
	handleFile: PropTypes.func
};

export default FileUpload;
